// Check if a feature is enabled

function isFeatureEnabled(featureId) {
  if (settings.features[featureId] === true) {
    return true;
  }
  return false;
}

// Check if we are on a mobile device

function isMobileDevice() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

// Show a notice

function notice(message, color) {
  new jBox('Notice', {
    content: message,
    addClass: 'notice-bim360',
    color: color || 'black',
    attributes: {
      x: 'right',
      y: 'bottom'
    },
    position: {
      x: 8,
      y: 8
    },
    autoClose: 6000
  });
}

function error(message) {
  notice(message || __('error'), 'red');
}

function success(message) {
  notice(message, 'green');
}

// Set a buttons percent status

function setButtonLoadingStatus(button, text, percent) {
  button = $(button);
  button.removeClass('loading-bar');
  button.html(text);
  percent = 100 - parseInt(percent);
  button.css({
    backgroundImage:
      'linear-gradient(to left, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.4) ' +
      percent +
      '%, rgba(255, 255, 255, 0.0) ' +
      percent +
      '%, rgba(255, 255, 255, 0.0) 100%)'
  });
}

function resetButtonLoadingStatus(button, text) {
  button = $(button);
  button.html(text);
  button.removeAttr('style');
}

// Get KB, MB, ... from bytes

function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

// Get a search param by name

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Return an array with English month names

function getMonthNames(lang) {
  var monthNames = {
    en: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    de: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember'
    ]
  };

  return monthNames[lang] || monthNames['en'];
}

// Return an array with abbreviated English month names

function getAbbrMonthNamesEN() {
  return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
}

// Return an array with abbreviated German month names

function getAbbrMonthNamesDE() {
  return ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
}

// Return parsed units

function getParsedUnits(units) {
  return units.replace('m2', 'm<sup>2</sup>').replace('m3', 'm<sup>3</sup>');
}

// Textfield errors

function addTextfieldError(selector) {
  $(selector)
    .addClass('error')
    .on('input.textfieldError', function () {
      removeTextfieldError(selector);
    });
}

function removeTextfieldError(selector) {
  $(selector).removeClass('error').off('input.textfieldError');
}

// Selectfield errors

function addSelectfieldError(selector) {
  $(selector).addClass('error');
}

function removeSelectfieldError(selector) {
  $(selector).removeClass('error');
}
